import * as React from 'react';
import { sentByFacet, subjectFacet, recievedDateFacet, folderFacet } from '../Schema/Facets';
import { getParameterStore } from '../store/ParametersStore';
import { createFacetColumn } from '@ms/items-view/lib/private/components/columns/createColumn';
import { fileTypeIconColumn } from '@ms/items-view/lib/private/components/columns/fileTypeIcon/fileTypeIconColumn';
import { TextField } from '@ms/items-view/lib/private/components/fields/text/TextField';
import { MailboxType } from 'owa-client-ids';
import { NameColumn } from '../components/NameColumn';
import {
    NameColumnText,
    SentByColumnText,
    SubjectColumnText,
    RecievedDateColumnText,
    FolderColumnText,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import AttachmentItemsSortBy from 'owa-service/lib/contract/AttachmentItemsSortBy';

export const nameColumn = {
    key: 'name',
    name: loc(NameColumnText),
    minWidth: 200,
    onRender: (item: { key: string }) => {
        return <NameColumn itemKey={item.key} />;
    },
};

const sentByColumn = createFacetColumn(
    {
        key: 'sentBy',
        name: loc(SentByColumnText),
        minWidth: 200,
    },
    {
        sentBy: sentByFacet,
    },
    TextField
)((facets: { sentBy?: typeof sentByFacet.type }) => {
    const sentBy = facets.sentBy;

    return {
        text: sentBy || '',
    };
});

const subjectColumn = createFacetColumn(
    {
        key: 'subject',
        name: loc(SubjectColumnText),
        minWidth: 200,
    },
    {
        subject: subjectFacet,
    },
    TextField
)((facets: { subject?: typeof subjectFacet.type }) => {
    const subject = facets.subject;

    return {
        text: subject || '',
    };
});

const recievedDateColumn = createFacetColumn(
    {
        key: 'recievedDate',
        name: loc(RecievedDateColumnText),
        minWidth: 200,
    },
    {
        recievedDate: recievedDateFacet,
    },
    TextField
)((facets: { recievedDate?: typeof recievedDateFacet.type }) => {
    const recievedDate = facets.recievedDate;

    return {
        text: `${recievedDate}` || '',
    };
});

const folderColumn = createFacetColumn(
    {
        key: 'folder',
        name: loc(FolderColumnText),
        minWidth: 200,
    },
    {
        folder: folderFacet,
    },
    TextField
)((facets: { folder?: typeof folderFacet.type }) => {
    const folder = facets.folder;

    return {
        text: folder || '',
    };
});

// Due to Fabric v6/v7 mismatch, we can't simply use `IColumn[]` here.
export function getColumns(selectedColumn: number[]): (typeof fileTypeIconColumn)[] {
    const columns: (typeof fileTypeIconColumn)[] = [
        fileTypeIconColumn,
        nameColumn,
        sentByColumn,
        subjectColumn,
        recievedDateColumn,
    ];

    const parameterStore = getParameterStore();
    if (parameterStore.mailboxInfo && parameterStore.mailboxInfo.type === MailboxType.UserMailbox) {
        columns.push(folderColumn);
    }

    for (let i = 0; i < columns.length; i++) {
        columns[i].isSorted = false;
        columns[i].isSortedDescending = false;
    }

    if (selectedColumn[0] === 0) {
        return columns;
    } else if (selectedColumn[0] === AttachmentItemsSortBy.AttachmentName) {
        columns[1].isSorted = true;
        if (selectedColumn[1]) {
            columns[1].isSortedDescending = true;
        }
    } else if (selectedColumn[0] === AttachmentItemsSortBy.AttachmentFrom) {
        columns[2].isSorted = true;
        if (selectedColumn[1]) {
            columns[2].isSortedDescending = true;
        }
    } else if (selectedColumn[0] === AttachmentItemsSortBy.AttachmentSubject) {
        columns[3].isSorted = true;
        if (selectedColumn[1]) {
            columns[3].isSortedDescending = true;
        }
    } else if (selectedColumn[0] === AttachmentItemsSortBy.AttachmentReceivedTime) {
        columns[4].isSorted = true;
        if (selectedColumn[1]) {
            columns[4].isSortedDescending = true;
        }
    }

    return columns;
}
